<div
  class="d-flex align-items-center justify-content-between gap-3 p-3 border rounded bg-light"
>
  <div class="d-flex align-items-center gap-2">
    <label class="fw-semibold pe-3 mb-0" for="status">Stato:</label>
    @if (!isPartner) {
      <select
        id="status"
        class="form-select"
        style="width: auto; min-width: 200px"
        [formControl]="requestState"
      >
        <option value="NUOVA">NUOVA</option>
        <option value="INVIATO PREVENTIVO">INVIATO PREVENTIVO</option>
        <option value="PREVENTIVO ACCETTATO">PREVENTIVO ACCETTATO</option>
        <option value="SELEZIONE ATTIVA">SELEZIONE ATTIVA</option>
        <option value="INVIATO CV">INVIATO CV</option>
        <option value="DA PAGARE">DA PAGARE</option>
        <option value="PAGATO">PAGATO</option>
        <option value="SELEZIONE COMPLETATA">SELEZIONE COMPLETATA</option>
        <option value="STAND-BY">STAND-BY</option>
        <option value="NON RISPONDE">NON RISPONDE</option>
        <option value="DA RICHIAMARE">DA RICHIAMARE</option>
        <option value="NON PIU’ INTERESSATO">NON PIU’ INTERESSATO</option>
      </select>
    } @else {
      <select
        id="status"
        class="form-select"
        style="width: auto; min-width: 200px"
        [formControl]="requestState"
      >
        <option value="NUOVA">NUOVA</option>
        <option value="INVIATO CV">INVIATO CV</option>
        <option value="DA PAGARE">DA PAGARE</option>
        <option value="PAGATO">PAGATO</option>
        <option value="NON PIU’ INTERESSATO">NON PIU’ INTERESSATO</option>
        <option value="SELEZIONE COMPLETATA">SELEZIONE COMPLETATA</option>
      </select>
    }
  </div>
  <button
    (click)="updateState()"
    [disabled]="!hasChanges"
    class="btn btn-primary text-white"
  >
    Salva
  </button>
</div>
